<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex justify-end">
        <base-button @click="onOpenNewTemplate">Tambah Template</base-button>
      </div>
      <datatable
        :columns="[
          { id: 'name', name: 'Nama' },
          { id: 'action', name: 'Aksi', theadClass: 'text-center' },
        ]"
        :total="templates.meta.page.total"
        :perPage="templates.meta.page.perPage"
        :currentPage="templates.meta.page.currentPage"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="template in templates.data"
            :key="template.id"
            :class="[classes.tr, 'bg-white hover:bg-green-100']"
          >
            <td
              :class="[classes.td, 'cursor-pointer']"
              @click="onOpenDetailTemplate(template)"
            >
              {{ template.attributes.name }}
            </td>
            <td :class="classes.td">
              <div class="flex items-center justify-center gap-1">
                <base-button size="sm" @click="onOpenEditTemplate(template)"
                  >Edit</base-button
                >
                <base-button
                  size="sm"
                  color="danger"
                  @click="onOpenDeleteTemplate(template)"
                  >Hapus</base-button
                >
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>
    <base-modal
      :showing="detailTemplate.visible"
      @close="detailTemplate.visible = false"
    >
      <base-card :with-style="false" title="Detail Template Broadcast">
        <div class="space-y-4">
          <div>
            <p class="mb-1 text-sm font-medium">Nama Template</p>
            <p class="text-sm leading-6 text-gray-700">
              {{ detailTemplate.name }}
            </p>
          </div>
          <div>
            <p class="mb-1 text-sm font-medium">Konten Template</p>
            <p class="text-sm leading-6 text-gray-700">
              {{ detailTemplate.content }}
            </p>
          </div>
        </div>
      </base-card>
    </base-modal>
    <base-modal
      :showing="formTemplate.visible"
      @close="formTemplate.visible = false"
    >
      <base-card
        :with-style="false"
        :title="
          formTemplate.id
            ? 'Edit Template Broadcast'
            : 'Tambah Template Broadcast'
        "
      >
        <form class="space-y-4" @submit.prevent="onSaveTemplate">
          <base-input
            fullwidth
            :shadow="false"
            label="Nama Template"
            inset
            placeholder="Masukkan Nama Template"
            type="text"
            v-model="formTemplate.name"
          />
          <div class="space-y-1">
            <base-input
              fullwidth
              :shadow="false"
              label="Isi Template"
              inset
              placeholder="Masukkan Isi Template"
              tag="textarea"
              v-model="formTemplate.content"
            />
            <p class="text-xs text-gray-500">
              Gunakan &lt;&lt;code&gt;&gt; untuk format kode,
              &lt;&lt;name&gt;&gt; untuk format nama.
            </p>
          </div>
          <div class="space-x-2">
            <base-button :disabled="!formTemplate.name || !formTemplate.content"
              >Simpan</base-button
            >
            <base-button
              type="button"
              color="white"
              @click="formTemplate.visible = false"
              >Batal</base-button
            >
          </div>
        </form>
      </base-card>
    </base-modal>
    <base-confirm
      :visible="deleteTemplate.visible"
      icon-type="badge"
      title="Konfirmasi Hapus Template"
      message="Template yang dihapus tidak dapat dikembalikan lagi, lanjutkan?"
      confirm-text="Ya"
      @close="deleteTemplate.visible = false"
      @confirmed="onConfirmDeleteTemplate"
    />
    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '../../../../mixins/request/request';
import BaseModal from '../../../../components/base/BaseModal.vue';
import BaseConfirm from '../../../../components/base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: { BaseModal, BaseConfirm },
  data() {
    return {
      loadingTemplates: true,
      loadingSaveTemplate: false,
      formTemplate: {
        visible: false,
        id: null,
        name: null,
        content: null,
      },
      detailTemplate: {
        visible: false,
        name: null,
        content: null,
      },
      deleteTemplate: {
        visible: false,
        id: null,
      },
      templates: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    loading() {
      return this.loadingTemplates || this.loadingSaveTemplate;
    },
  },
  methods: {
    async loadTemplates(params) {
      this.loadingTemplates = true;

      const [res, err] = await this.request(
        `/api/v1/whatsapp-broadcast-templates`,
        {
          params: {
            'fields[whatsapp-broadcast-templates]': 'name,content',
            'page[size]': 5,
            ...params,
          },
        }
      );

      if (!err) {
        this.templates = res;
      }

      this.loadingTemplates = false;
    },
    onChangePage(page) {
      this.loadTemplates({
        'page[number]': page,
      });
    },
    onOpenDetailTemplate(template) {
      this.detailTemplate.name = template.attributes.name;
      this.detailTemplate.content = template.attributes.content;
      this.detailTemplate.visible = true;
    },
    onOpenEditTemplate(template) {
      this.formTemplate.id = template.id;
      this.formTemplate.name = template.attributes.name;
      this.formTemplate.content = template.attributes.content;
      this.formTemplate.visible = true;
    },
    onOpenDeleteTemplate(template) {
      this.deleteTemplate.id = template.id;
      this.deleteTemplate.name = template.attributes.name;
      this.deleteTemplate.content = template.attributes.content;
      this.deleteTemplate.visible = true;
    },
    onOpenNewTemplate() {
      this.formTemplate.id = null;
      this.formTemplate.name = null;
      this.formTemplate.content = null;
      this.formTemplate.visible = true;
    },
    async onSaveTemplate() {
      this.loadingSaveTemplate = true;

      const [, err] = await this.request(
        this.formTemplate.id
          ? `/api/v1/whatsapp-broadcast-templates/${this.formTemplate.id}`
          : `/api/v1/whatsapp-broadcast-templates`,
        {
          method: this.formTemplate.id ? 'patch' : 'post',
          data: {
            data: {
              ...(this.formTemplate.id ? { id: this.formTemplate.id } : {}),
              type: 'whatsapp-broadcast-templates',
              attributes: {
                name: this.formTemplate.name,
                content: this.formTemplate.content,
              },
            },
          },
        }
      );

      if (!err) {
        this.formTemplate.visible = false;

        this.loadTemplates();
      }

      this.loadingSaveTemplate = false;
    },
    async onConfirmDeleteTemplate() {
      this.loadingSaveTemplate = true;

      const [, err] = await this.request(
        `/api/v1/whatsapp-broadcast-templates/${this.deleteTemplate.id}`,
        {
          method: 'delete',
        }
      );

      if (!err) {
        this.deleteTemplate.visible = false;

        this.loadTemplates();
      }

      this.loadingSaveTemplate = false;
    },
  },
  created() {
    this.loadTemplates();
  },
};
</script>
